module.exports = __webpack_public_path__ + "static/media/voice-overs.c3c3c66e.svg";